import AbstractAccordion from './AbstractAccordion'
import { shallowRef } from 'vue'
import CTAComponent from '@/modules/common/common/components/insuranceAccordions/CTAComponent.vue'

export default class AccordionCTA extends AbstractAccordion<{
  link: string
  linkText: string
  text: string
  title: string
}> {
  component = shallowRef(CTAComponent)

  constructor(attributes: Partial<AccordionCTA>) {
    super(attributes)
  }
}
